import localeConstructor from "./Constructor";
import './localeMoment.js';

if (typeof __ == "undefined") {
	let locale = new localeConstructor(); 
	window.__ = locale.init();
	window.__addPrimary = locale.add;
  window.__localeName = locale.getLocale;
}

export default window.__





// WEBPACK FOOTER //
// ./src/locale/index.js